var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"z-index":"1000","color":"#000000","value":_vm.isPending,"opacity":_vm.opacity}},[_c('v-progress-circular',{attrs:{"color":_vm.color,"indeterminate":"","size":"64","width":"5"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }